<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('nav.home')}}</router-link></li>
        <i v-if="userLang" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">{{$t('realEstateBulletin')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">

        <div class="row pt-2" v-if="rows.length">
          <div class="col">
            <div class="font-30 almarai-bold">{{$t('latestRealEstate_Updates')}}</div>
            <!-- <div class="font-color-41 pt-2">{{$t('exampleServiceDescription')}}</div>
            <p class="font-color-41">{{$t('notaryPublic')}}</p> -->
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-md-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>
          </div>
        </div>

        <div v-if="isLoading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div  v-else class="row">
          <div class="col">
            <div class="row" v-if="!rows.length">
              <div class="col">
                <div class="row justify-content-center">
                <div class="col text-center">
                  <div>
                    <img src="/assets/images/page404.png" class="max-35-percent" alt="">
                  </div>
                </div>
              </div>
              <div class="row justify-content-center pt-3">
                  <div class="col text-center">
                    <!-- <p>الصفحة غير موجودة!</p> -->
                    <p class="font-30 almarai-bold" >{{$t('nav.realEstatePublications')}}</p>
                    <!-- <span>عذراً، الصفحة التي تبحث عنها غير متاحة أو قد تم حذفها، نرجو العودة </span><br>
                    <span>إلى الصفحة الرئيسية.</span> -->
                  </div>
                </div>
                <div class="row justify-content-center pt-3">
                  <div class="col-11 col-md-5 text-center">
                    <router-link to="/">
                      <div class="btn-black">{{$t('homepage')}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-12 col-md-4 bulletin" v-for="(row, index) in rows" :key="index">
                <div class="card realEstateBulletin">
                  <div class="card-body">
                    <div>
                      <img :src="MEDIA_URL+row.image" class="w-100"  alt="">
                    </div>
                    <div class="row pt-2">
                      <div class="col almarai-bold">
                        {{row.title}}
                      </div>
                    </div>
                    <div class="row pt-1">
                      <div class="col font-color-84">
                        <img src="/assets/images/icons/calendar-03.png" class="max-20" alt="">
                        <span class="mx-1">{{$t('publishedIn')}}</span>
                        <span class="mx-1">{{row.publishDate}}</span>
                      </div>
                    </div>
                    <div class="row pt-3">
                      <div class="col-auto">
                        <a :href="MEDIA_URL+row.pdfFile" target="_blank">
                          <div class="btn-SmallBlack">{{$t('viewFile')}}</div>
                        </a>
                      </div>
                      <div class="col-auto p-0" @click.prevent="downloadPdf(MEDIA_URL+row.pdfFile)">
                        <div class="btn-Small-W">{{$t('download')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "realEstateBulletin",
  data(){
    return{
      isLoading: true,
      message: "",
      hasError: false,
      errorNumber: 0,
      rows: [],
      userLang: 'ar',
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','BASE_URL'])
  },
  methods:{
    latestNews(){
      this.$http.get('/api/LatestNews/list').then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        this.isLoading = false;
      }).catch(err => {
        console.log(err);
        this.isLoading = false;
      })
    },

    async downloadPdf(fileUrl){
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "aqaralmuhaysini.pdf";
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    },
  },
  created(){
    this.latestNews();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>